import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { ifLinks, mmLinks } from 'constants/links';
import Modal from 'honeydew/Modal';
import useGlobalStore from 'hooks/useGlobalStore';

function BoostedTermsModal({ setShowBoostedTermsModal, showBoostedTermsModal, termsAndConditions }) {
    const { isMisfitsTheme } = useGlobalStore();

    return (
        <Modal
            open={showBoostedTermsModal}
            onClose={() => setShowBoostedTermsModal(false)}
            headline="Terms & Conditions"
            centered
        >
            <p>{termsAndConditions}</p>
            <p className="mt-20">
                Please visit our{' '}
                <Link className="link" to="/account/referrals" onClick={() => setShowBoostedTermsModal(false)}>
                    Referral page
                </Link>{' '}
                and{' '}
                <a
                    className="link"
                    href={isMisfitsTheme ? mmLinks.terms : ifLinks.terms}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Terms of Service
                </a>{' '}
                for complete details.
            </p>
        </Modal>
    );
}

BoostedTermsModal.propTypes = {
    setShowBoostedTermsModal: PropTypes.func.isRequired,
    showBoostedTermsModal: PropTypes.bool.isRequired,
    termsAndConditions: PropTypes.string.isRequired,
};

export default BoostedTermsModal;
